import script from "./phone.vue?vue&type=script&setup=true&lang=js"
export * from "./phone.vue?vue&type=script&setup=true&lang=js"

import "./phone.vue?vue&type=style&index=0&id=4b9ef980&lang=scss&scoped=true"

import exportComponent from "/home/kain/brighten-legacy/brightenflower2024-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b9ef980"]])

export default __exports__